// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file html_template.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file html_template.proto.
 */
export const file_html_template: GenFile = /*@__PURE__*/
  fileDesc("ChNodG1sX3RlbXBsYXRlLnByb3RvEgtncnBjLmFwaS52MSLWAQoMSHRtbFRlbXBsYXRlEgoKAmlkGAEgASgDEgwKBHR5cGUYAiABKAkSDAoEbmFtZRgDIAEoCRIOCgZkZXNpZ24YBCABKAkSDAoEaHRtbBgFIAEoCRIRCglwbGFpbnRleHQYBiABKAkSDgoGcGFyYW1zGAcgASgJEg8KB3ByZXZpZXcYCCABKAkSEQoJZHRfY3JlYXRlGAkgASgDEhEKCWR0X3VwZGF0ZRgKIAEoAxISCgppc19kZWxldGVkGAsgASgIEhIKCmlzX2RlZmF1bHQYDCABKAhCBloELjtwYmIGcHJvdG8z");

/**
 * @generated from message grpc.api.v1.HtmlTemplate
 */
export type HtmlTemplate = Message<"grpc.api.v1.HtmlTemplate"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string design = 4;
   */
  design: string;

  /**
   * @generated from field: string html = 5;
   */
  html: string;

  /**
   * @generated from field: string plaintext = 6;
   */
  plaintext: string;

  /**
   * @generated from field: string params = 7;
   */
  params: string;

  /**
   * @generated from field: string preview = 8;
   */
  preview: string;

  /**
   * @generated from field: int64 dt_create = 9;
   */
  dtCreate: bigint;

  /**
   * @generated from field: int64 dt_update = 10;
   */
  dtUpdate: bigint;

  /**
   * @generated from field: bool is_deleted = 11;
   */
  isDeleted: boolean;

  /**
   * @generated from field: bool is_default = 12;
   */
  isDefault: boolean;
};

/**
 * Describes the message grpc.api.v1.HtmlTemplate.
 * Use `create(HtmlTemplateSchema)` to create a new message.
 */
export const HtmlTemplateSchema: GenMessage<HtmlTemplate> = /*@__PURE__*/
  messageDesc(file_html_template, 0);

